import type SubjectTypeGrantView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectTypeGrantView';

/** One whole sentence per case: the French agreements are written out, never built from fragments. */
const describeAccess = (grants: readonly SubjectTypeGrantView[]): string => {
	const roleCount = grants.filter((grant) => grant.kind === 'role').length;
	const userCount = grants.length - roleCount;

	if (grants.length === 0) {
		return "Personne n'y a accès.";
	}

	if (userCount === 0) {
		return roleCount === 1 ? '1 rôle y a accès.' : `${roleCount} rôles y ont accès.`;
	}

	if (roleCount === 0) {
		return userCount === 1 ? '1 utilisateur y a accès.' : `${userCount} utilisateurs y ont accès.`;
	}

	if (roleCount === 1 && userCount === 1) {
		return '1 rôle et 1 utilisateur y ont accès.';
	}

	if (roleCount === 1) {
		return `1 rôle et ${userCount} utilisateurs y ont accès.`;
	}

	if (userCount === 1) {
		return `${roleCount} rôles et 1 utilisateur y ont accès.`;
	}

	return `${roleCount} rôles et ${userCount} utilisateurs y ont accès.`;
};

export default describeAccess;
